import tw, { styled } from 'twin.macro'
import React from 'react'
import PropTypes from 'prop-types'
import ButtonLink from './ButtonLink'

const Wrapper = styled('div')`
  ${props => props.applyVerticalMargin ? tw`my-8` : ''}
`

const HeadingWrapper = styled('div')`
  ${tw`mr-8`};
`

const Heading = styled('h2')`
  ${tw`text-white text-2xl`};
`

const SubHeading = styled('p')`
  ${tw`text-red-100 text-base italic`};
`

const CallToAction = ({ title, subtitle, buttonTitle, buttonLink, applyVerticalMargin, showButtons }) => {
  const hasCustomButton = buttonTitle && buttonLink ? true : false;

  function renderButtons() {
    if (hasCustomButton) {
      return <ButtonLink special borderLess to={buttonLink}>{buttonTitle}</ButtonLink>
    } else {
      return [
        <ButtonLink key="upload-spreadsheet" special borderLess to="/upload/">Upload Spreadsheet</ButtonLink>,
        <ButtonLink key="get-api-key" special borderLess to="https://dash.geocod.io/apikey/create">Get an API Key</ButtonLink>
      ];
    }
  }

  return (
    <Wrapper applyVerticalMargin={applyVerticalMargin}>
      <div tw="relative w-full bg-red-500 overflow-hidden shadow-xl">
        <div aria-hidden="true" tw="absolute inset-0 -mt-72 sm:-mt-32 md:mt-0">
          <svg tw="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 1463 360">
            <path tw="text-red-500 text-opacity-40" fill="currentColor" d="M-82.673 72l1761.849 472.086-134.327 501.315-1761.85-472.086z" />
            <path tw="text-red-700 text-opacity-40" fill="currentColor" d="M-217.088 544.086L1544.761 72l134.327 501.316-1761.849 472.086z" />
          </svg>
        </div>
        <div tw="relative md:flex items-center justify-center md:h-48 p-8 lg:px-8 lg:py-0">
          <HeadingWrapper>
            <Heading>{title}</Heading>
            {subtitle && <SubHeading>{subtitle}</SubHeading>}
          </HeadingWrapper>
          {showButtons && renderButtons()}
        </div>
      </div>
    </Wrapper>
  );
}

CallToAction.defaultProps = {
  applyVerticalMargin: false,
  showButtons: true
}

CallToAction.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonLink: PropTypes.string,
  applyVerticalMargin: PropTypes.bool,
  showButtons: PropTypes.bool
}

export default CallToAction
